export function setPlaceId(placeId) {
  sessionStorage.setItem('placeId', placeId)
}

export function getPlaceId() {
  return sessionStorage.getItem('placeId')
}

export function isEmpty(string) {
  if (string === "" || string === undefined || string === null) {
    return true
  } else {
    return false
  }
}
